export const CommonConsulateCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Consolati',
    path: '/sistema/geografiche/estero/consolato',
  },
];
